import api from '@state/api';
const workerEndPoint = `${process.env.WORKER_API}/workerapi/v1`;
export const getAnalytics = async (device, start, end, interval) => {
    const { data } = await api.post(`${workerEndPoint}/data?start=${start}&end=${end}&interval=${interval}`, device);
    return data;
};
